import React from 'react'
import dynamic from 'next/dynamic'
// @ts-ignore
import LogoWhite from '@ooka_default/components/icons/LogoWhite'
import Link from '@corratech/pylot-ui/src/Link'
import { useModal } from '@components/alfakher/pylot-megamenu/src/hooks'
import { useIsMobile } from '@components/common/IsMobile/useIsMobile'

// mobile mega menu should not be SSR, as burger still appears.
const MobileMegaMenu = dynamic(
    () => import('./components/MobileMegaMenu/MobileMegaMenu'),
    {
        ssr: false
    }
)

// Should be ssr to make sure that links are visible to users initially
const DesktopMegaMenu = dynamic(
    () =>
        import(
            'stores/ooka_usa_store/components/alfakher/pylot-megamenu/src/components/DesktopMegaMenu/DesktopMegaMenu'
        )
)

import cn from 'classnames'
import s from '@ooka_default/styles/common/menus/MegaMenu.module.scss'
// @ts-ignore
import { useNavMenu } from './hooks'
import { usePreloadedData } from 'preload'
import { useTranslation } from 'next-i18next'
import { useStoreConfig } from 'config'

export const MegaMenu = ({
    className,
    showCurrency,
    handleChatOpen
}: {
    className: string
    showCurrency?: boolean
    handleChatOpen: () => void
}): JSX.Element | null => {
    const config = useStoreConfig()
    const variables = config.preload.menu?.variables
    const [isOpen, setIsOpen] = useModal(false)
    const preloadedMenuData = usePreloadedData('menu')
    const { navigation: navigationData } = useNavMenu(
        { ...variables, onlyTopLevel: false },
        {
            initialData: preloadedMenuData,
            revalidateOnMount: true,
            revalidateOnFocus: false
        }
    )
    const { t } = useTranslation('common')

    const renderLogoAndNavigation = () => (
        <Link href="/">
            <span className={cn(s.logo, 'logo')} aria-label={t('Logo')}>
                <LogoWhite />
                <span className="sr-only">{t('Logo')}</span>
            </span>
        </Link>
    )
    const isMobileView = useIsMobile(1023)
    const renderBurger = () =>
        isMobileView && (
            <div
                className={cn(
                    s.burgerIcon,
                    { [s.activeBurger]: isOpen },
                    'burgerIcon'
                )}
                onClick={() => setIsOpen(!isOpen)}
                aria-hidden="true"
            >
                <span />
                <span />
                <span data-content="menu" />
            </div>
        )

    const closeMenuAndSearchBar = () => {
        setIsOpen(false)
    }

    return variables?.category_uid && navigationData ? (
        <>
            <div className={s['top-header-logo']}>
                {renderBurger()}
                {renderLogoAndNavigation()}
            </div>
            <div className={cn(className, s.megaMenuCms)}>
                {isMobileView ? (
                    <MobileMegaMenu
                        isOpen={isOpen}
                        setIsOpen={setIsOpen}
                        navData={navigationData}
                        showCurrency={showCurrency}
                        handleChatOpen={handleChatOpen}
                        closeMenuAndSearchBar={closeMenuAndSearchBar}
                    />
                ) : (
                    <DesktopMegaMenu navData={navigationData} />
                )}
            </div>
        </>
    ) : (
        <span>{t('Failed to load navigation menu')}</span>
    )
}
